import { render } from "./Chinese.vue?vue&type=template&id=68429d50"
const script = {}
script.render = render

export default script